import { Component } from '@angular/core';
import { Router } from '@angular/router';
import packageJson from '@json/package.json';
import { WebSocketsService } from '@services/web-sockets.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    public version: string = packageJson.version;
    public termsConditions: string = 'Términos y condiciones';
    public privacyPolicy: string = 'Politica de privacidad';
    public cookiesPolicy: string = 'Politica de cookies';

    public linkTermsConditions: string = 'https://globaleye.es/aviso-legal/';
    public linkPrivacyPolicy: string =
        'https://globaleye.es/politica-de-privacidad/';
    public linkCookiesPolicy: string =
        'https://globaleye.es/politica-de-cookies/';

    constructor() {}
}
